import React, { useEffect, useRef, useState } from 'react';
import "./exploretoservice.scss"

import EastIcon from '@mui/icons-material/East';
import WestIcon from '@mui/icons-material/West';
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import TrendingFlatIcon from '@mui/icons-material/TrendingFlat';

import { axiosApi } from '../../../../_helper/api_helper';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { industriesget } from '../../../../store/industries/action';




const ExploreToService = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
     const { getIndustries, loading, error } = useSelector(
            (state) => state.IndustriesReducers
        );
    const client_Id = localStorage.getItem("client_Id");
 
    const carouselRef = useRef(null);
    const [activeButton, setActiveButton] = useState(null);
    const [ServiceData, setServiceData] = useState([]);



    // useEffect(() => {
    //     categoriesGet();

    // }, []);
     useEffect(() => {
            if (getIndustries?.length > 0) {
                setServiceData(getIndustries);
            }
        }, [getIndustries]);


     useEffect(() => {
            dispatch(industriesget());
          }, [dispatch]);
    const categoriesGet = async () => {
        // const response = await axiosApi.get("/occupation-skills");
        const response = await axiosApi.get("/industries");
        setServiceData(response?.data)
    }

    const handleServiceNavigate = (item) => {
        if (client_Id) {
            navigate(`/Search-recuiter/skill/${item?.name}`);
        } else {
            navigate(`/Serach-Freelancer/industry/${item?.name}`);
        }
    }

    const scrollLeft = () => {
        if (carouselRef.current) {
            carouselRef.current.previous();
        }
        setActiveButton('left');
    }

    const scrollRight = () => {
        if (carouselRef.current) {
            carouselRef.current.next();
        }
        setActiveButton('right');
    }


    return (
        <>
            <div className="explore-to-service-home">
                <div className="home-explore-to-service">
                    <div className="explore-to-service-inner">
                        <div className="explore-to-service-first">
                            <h3>{client_Id?"Explore Top Projects by category":"Explore Top Service"}</h3>
                            <p>Hire Freelancers by Category - Find the Perfect Fit for Your Project Needs!</p>
                        </div>
                        <div className="explore-to-service-second">
                            <div className="inner-button" >
                                <div className="inner-button-carousel" >
                                    <button className={`carousel-button left ${activeButton === 'left' ? 'active' : ''}`} onClick={scrollLeft}><WestIcon className='icon-left' /></button>
                                    <button className={`carousel-button right ${activeButton === 'right' ? 'active' : ''}`} onClick={scrollRight}><EastIcon className='icon-left' /></button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>


                <div className="slick-carousel-explore-to-service" >
                    <div className="slick-carousel-explore-to-service-container">
                        {ServiceData?.length > 0 &&
                            <div>
                                <Carousel
                                    ref={carouselRef}
                                    additionalTransfrom={0}
                                    arrows={false}
                                    autoPlaySpeed={3000}
                                    centerMode={false}
                                    className=""
                                    containerClass="carousel-container"
                                    customButtonGroup={<button></button>}
                                    dotListClass=""
                                    draggable
                                    focusOnSelect={false}
                                    infinite
                                    itemClass=""
                                    keyBoardControl
                                    minimumTouchDrag={80}
                                    renderButtonGroupOutside={false}
                                    renderDotsOutside={false}
                                    responsive={{
                                        desktop: {
                                            breakpoint: {
                                                max: 3000,
                                                min: 1024
                                            },
                                            items: 4
                                        },
                                        mobile: {
                                            breakpoint: {
                                                max: 464,
                                                min: 0
                                            },
                                            items: 1
                                        },
                                        tablet: {
                                            breakpoint: {
                                                max: 1024,
                                                min: 464
                                            },
                                            items: 2
                                        }
                                    }}
                                    showDots={false}
                                    sliderClass=""
                                    slidesToSlide={1}
                                    swipeable
                                >
                                    {ServiceData.map((item, index) => (
                                        <>
                                            <div className='explore-card-container'>
                                                <div className="explore-card-container-inner">
                                                    <div onClick={()=>handleServiceNavigate(item)}  key={index} className='explore-card-container-img'>

                                                        <img src={`${axiosApi.defaults.baseURL}${item?.in_icon}`} alt="" />
                                                        <div  className="explore-service-content">
                                                            <h6>{item?.name}</h6>
                                                            <div className="explore-service-icon">
                                                                <TrendingFlatIcon />
                                                            </div>

                                                        </div>

                                                    </div>


                                                </div>

                                            </div>

                                        </>

                                    ))}
                                </Carousel>
                            </div>
                        }
                    </div>


                </div>
            </div>

        </>
    )
}

export default ExploreToService
